module.exports = __webpack_public_path__ + "static/img/1_0029.82647ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0029.jpg
// module id = hx75
// module chunks = 0